var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","justify-content":"center","height":"80vh","align-items":"center"}},[_c('van-overlay',{attrs:{"show":_vm.isLoading}},[_c('div',{staticClass:"wrapper"},[(_vm.isLoading == true)?_c('loading'):_vm._e()],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }